export interface ApiErrorEntry {
  method: string;
  url: string;
  requestBody?: unknown;
  status?: number;
  responseBody?: unknown;
  errorMessage: string;
  timestamp: string;
}

const MAX_ENTRIES = 5;
const log: ApiErrorEntry[] = [];

export function logApiError(entry: Omit<ApiErrorEntry, "timestamp">): void {
  log.unshift({ ...entry, timestamp: new Date().toISOString() });
  if (log.length > MAX_ENTRIES) log.length = MAX_ENTRIES;
  window.dispatchEvent(new Event("api-debug-update"));
}

export function getApiErrorLog(): ApiErrorEntry[] {
  return log;
}
